var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "#ADB5BD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 33C60 47.3594 48.3594 59 34 59C19.6406 59 8 47.3594 8 33C8 18.6406 19.6406 7 34 7C48.3594 7 60 18.6406 60 33ZM52.9867 56.2284C47.815 60.4607 41.2041 63 34 63C17.4315 63 4 49.5685 4 33C4 16.4315 17.4315 3 34 3C50.5685 3 64 16.4315 64 33C64 40.9243 60.9276 48.131 55.909 53.4939L68.0247 65.6095C68.8057 66.3906 68.8057 67.6569 68.0247 68.438C67.2436 69.219 65.9773 69.219 65.1963 68.438L52.9867 56.2284Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 29.5C29 30.8807 27.8807 32 26.5 32C25.1193 32 24 30.8807 24 29.5C24 28.1193 25.1193 27 26.5 27C27.8807 27 29 28.1193 29 29.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 29.5C44 30.8807 42.8807 32 41.5 32C40.1193 32 39 30.8807 39 29.5C39 28.1193 40.1193 27 41.5 27C42.8807 27 44 28.1193 44 29.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.25 39C22.25 38.0335 23.0335 37.25 24 37.25H44C44.9665 37.25 45.75 38.0335 45.75 39C45.75 39.9665 44.9665 40.75 44 40.75H24C23.0335 40.75 22.25 39.9665 22.25 39Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadFace);
export default __webpack_public_path__ + "static/media/bad-face.9c74ee9d.svg";
export { ForwardRef as ReactComponent };